import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { StrongAuthenticationSessionHistory } from '@lemon/core-firebase/model/tunnistaminen'
import { Observable } from 'rxjs'

@Component({
  templateUrl: './kayttaja.strong-auth-history.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class KayttajaStrongAuthHistoryDialog implements OnInit {
  strongAuthHistoryObservable: Observable<StrongAuthenticationSessionHistory>

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: StrongAuthenticationSessionHistory[],
    private _dialogRef: MatDialogRef<KayttajaStrongAuthHistoryDialog>,
  ) {}

  ngOnInit() {}

  sulje() {
    this._dialogRef.close()
  }
}
